import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  className?: string;
  action?: string;
  method?: "get" | "post";
  onSubmit?: (e: any) => void;
  onKeyPress?: (e: any) => void;
};

const Form = ({
  children,
  className,
  action,
  method,
  onSubmit,
  onKeyPress,
}: PropsWithChildren<Props>) => (
  <form
    action={action}
    method={method}
    onSubmit={onSubmit}
    onKeyPress={onKeyPress}
    className={clsx({
      [`${className ? className : ""}`]: className,
    })}
  >
    {children}
  </form>
);

export default Form;
